import "./style.css";

document.addEventListener("DOMContentLoaded", () => {
  console.log("Figma to HTML Prototype Loaded");

  const app = document.getElementById("app");
});
